const SessionStorageServices = (() => {
  const storage = window.sessionStorage;
  const { REACT_APP_CARRIER_ID: CARRIER_ID, REACT_APP_NODE_ENV: NODE_ENV } = process.env;
  const identityObjName = `${CARRIER_ID}.${window.location.host}.identity`;
  const termlifRetryKey = `${CARRIER_ID}.${NODE_ENV}.termlifeRetry`;
  const termlifePayloadKey = `${CARRIER_ID}.${NODE_ENV}.termlifePayload`;

  const _setIdentity = (uid, identity) => {
    storage.setItem(`${identityObjName}.${uid}`, identity);
  };

  const _getIdentity = (uid) => {
    return storage.getItem(`${identityObjName}.${uid}`);
  };

  const _clearIdentity = (uid) => {
    storage.removeItem(`${identityObjName}.${uid}`);
  };

  const _setLocalValue = (key, value) => {
    storage.setItem(key, value);
  };

  const _getLocalValue = (key, parse) => {
    const sessionValue = storage.getItem(key);
    if (parse) {
      try {
        return JSON.parse(sessionValue);
      } catch {
        return sessionValue;
      }
    }
    return sessionValue;
  };

  const _removeLocalValue = (key) => {
    return storage.removeItem(key);
  };

  /* GET/SET CONFIG */

  const _getRetrySignKeys = () => {
    const termlifeApiRetry = storage.getItem(termlifRetryKey);
    const _payload = storage.getItem(termlifePayloadKey);
    let termlifeApiPayload;
    try {
      termlifeApiPayload = JSON.parse(_payload);
    } catch {
      termlifeApiPayload = _payload;
    }
    return { termlifeApiRetry, termlifeApiPayload };
  };

  const _setRetrySignKeys = (payload) => {
    storage.setItem(termlifRetryKey, true);
    storage.setItem(termlifePayloadKey, JSON.stringify(payload));
  };

  const _removeRetrySignKeys = () => {
    storage.removeItem(termlifRetryKey);
    storage.removeItem(termlifePayloadKey);
  };

  return {
    setIdentity: _setIdentity,
    getIdentity: _getIdentity,
    clearIdentity: _clearIdentity,
    setLocalValue: _setLocalValue,
    getLocalValue: _getLocalValue,
    removeLocalValue: _removeLocalValue,
    getRetrySignKeys: _getRetrySignKeys,
    setRetrySignKeys: _setRetrySignKeys,
    removeRetrySignKeys: _removeRetrySignKeys,
  };
})();

export default SessionStorageServices;
